import { GovIcon } from '@gov-design-system-ce/react';
import type { DatovkaApiType } from '@gov-nx/api';
import {
	dataBoxLabel,
	getDataBoxIcon,
	useDataBoxLabel,
} from '@gov-nx/module/data-box';
import { HighlightTextMemo } from '@gov-nx/utils/common';

export const DataBoxListItem = ({
	dataBox,
	searchValue,
}: {
	dataBox: DatovkaApiType;
	searchValue: string;
}) => {
	const { label } = useDataBoxLabel();

	return (
		<div className="w-full flex flex-col gap-(--templates-margin-s)">
			<div className="flex flex-col [ md:flex-row ]">
				<strong className="md:pr-3">
					<HighlightTextMemo
						text={dataBoxLabel(dataBox, true)}
						search={searchValue}
					/>
				</strong>
				<span className="text-body-s text-(--text-secondary) [ md:pl-3 md:border-l md:border-(--border-subtlest) ]">
					<HighlightTextMemo
						text={dataBox.datovaSchrankaId || ''}
						search={searchValue}
					/>
				</span>
			</div>
			<div className="flex items-center gap-(--spacing-s) text-body-s">
				<GovIcon
					name={getDataBoxIcon(dataBox.typSchranky) ?? ''}
					type="templates"
				/>
				{dataBox.typSchranky ? label(dataBox.typSchranky) : null}
			</div>
			<div className="flex items-center gap-(--spacing-s) text-body-s">
				<GovIcon
					name="geo-alt-fill"
					type="components"
				/>
				<HighlightTextMemo
					text={dataBox.adresa || ''}
					search={searchValue}
				/>
			</div>
		</div>
	);
};
